import React, { useEffect, useState } from "react";
import { SelectUi } from "../../ui/SelectUi";
import { get_tiposmovimientos_devolucion } from "../../../actions/inventario";

export const TipoMovimientoDevolucionSelect = ({ ...props }) => {
  const [tipomovimientos, setTipomovimientos] = useState([]);
  const OnLoadTipoMovimientos = async () => {
    const datos = await get_tiposmovimientos_devolucion();
    setTipomovimientos(datos);
  };
  useEffect(() => {
    OnLoadTipoMovimientos();
  }, []);

  return <SelectUi data={tipomovimientos} {...props} />;
};
